import Page from "../../components/Page";

export default function Fascinating() {
  return (
    <Page title="Fascinating Facts and Quotes About Food">
    
      <h4>HEALTHIER FOOD CHOICES: Did you know...</h4>
      <br />
      <b>Protein, Health, & Fitness:</b>{" "}
      <p>
        {" "}
        Did you know that a diet consisting of a variety of beans and lentils,
        fruits and vegetables, whole grains, nuts and seeds has all the proteins
        people need to be healthy and active? There are many world class vegan
        athletes, including Carl Lewis, winner of nine Olympic gold medals in
        track and field, and fellow vegan Ricky Williams, Heisman Trophy winning
        running back for the Miami Dolphins.{" "}
      </p>
      <br />
      <b>Nutritional Needs:</b>{" "}
      <p>
        {" "}
        Did you know that virtually all vitamins, minerals, and amino acids are
        created in soil or plants? That's why people who eat only plant foods
        can obtain plenty of protein, iron, calcium and other important
        nutrients.
      </p>
      <br />
      <b>The China Study</b>{" "}
      <p>
        {" "}
        generated massive volumes of comprehensive data, suggesting that the
        more animal protein we eat, the greater our risk for cardiovascular
        disease, diabetes, kidney disease, osteoporosis and autoimmune diseases.
        The director of that ground-breaking study also concluded that the
        consumption of animal products causes more cancers than does any
        chemical carcinogen.
      </p>
      <br />
      <b>Heart Disease:</b>{" "}
      <p>
        The clinical studies of medical doctor Dean Ornish have shown us that
        most patients who followed standard medical advice for coronary artery
        blockages got worse, while those who adopted a total vegetarian diet
        coupled with lifestyle changes showed improvement, including reversal of
        coronary artery blockages.
      </p>
      <br />
      <b>Diabetes:</b>{" "}
      <p>
        Health professionals used to believe that once we develope diabetes, we
        are stuck with it. The clinical studies of Neal Barnard, MD, which were
        funded by the National Institute of Health, have shown that it is
        possible to repair insulin function and reverse Type-2 diabetes. Long
        term adherence to a diet that includes meat just once a week or more is
        linked to a 74% increase in the chance of developing diabetes.
      </p>
      <br />
      <b>Heart Disease:</b>{" "}
      <p>
        {" "}
        Cleveland Clinic physician Dr. Caldwell Esselstyn has convincingly shown
        that even severe coronary artery disease is completely reversible thru
        dietary change. Seventeen patients with advanced heart disease went on
        his vegan dietary plan. 49 cardiac events had previously occurred in
        this group, and 5 patients had been given less than a year to live. 23
        years later, all were still alive and free of heart disease symptoms.
      </p>
      <br />
      <b>Lactose intolerance</b>{" "}
      <p>
        {" "}
        is not a disorder. It’s normal. Most of us lose the ability to digest
        milk sugars upon weaning, usually in our third year of life. 70% of the
        world's population fits this profile. And calcium deficiency and
        osteoporosis are rare in populations with low dairy consumption.
      </p>
      <br />
      <b>Antibiotics</b>
      <p>
        {" "}
        are routinely fed to chickens, turkeys, pigs, and dairy cows in massive
        amounts. As a result, bacterial resistance to antibiotic treatment of
        humans has jumped dramatically since the 1970s.
      </p>
      <br />
      <b>Milk</b>{" "}
      <p>
        Did you know that there is virtually no evidence that drinking two or
        three glasses of milk a day reduces the chances of breaking a bone? … or
        that the highest hip fracture rates are found in the countries in which
        the most dairy products are consumed?
      </p>
      <br />
      <b>Chickens:</b>{" "}
      <p>
        {" "}
        Those who have witnessed the conditions in which chickens are raised and
        killed can understand why poultry is the most common cause of food
        poisoning in the home. The Atlanta Journal Constitution interviewed 84
        federal poultry inspectors and found that more than two-thirds of them
        were so concerned that they had stopped eating chickens, themselves.
      </p>
      <br />
      <b>Erectile Dysfunction:</b>{" "}
      <p>
        {" "}
        Did you know that physicians are now using male erectile dysfunction as
        a marker for heart disease? The artery that leads down there can become
        clogged or damaged, just like any other. It can also be restored to
        vitality, like any other. Let food be your medicine!
      </p>
      <br />
      <b>Food Borne Illness:</b>{" "}
      <p>
        {" "}
        According to the U.S. Department of Agriculture, the major food borne
        microorganisms that make people sick and can even kill them – viruses,
        bacteria, parasites, and fungi – occur mainly in “meat, poultry,
        seafood, dairy products and eggs” (Buzby & Roberts).
      </p>
      <br />
      <h4>COMPASSIONATE FOOD CHOICES: Did you know…</h4>
      <br />
      <b>Farmed Animals:</b>{" "}
      <p>
        The vast majority of farmed animals today are raised in appalling
        conditions, which few of us would want to imagine, let alone experience.
        The federal Animal Welfare Act offers no protection, because it doesn’t
        even apply to farmed animals. And the few state laws that exist are
        often simply ignored.
      </p>
      <br />
      <b>Dairy Industry:</b>{" "}
      <p>
        {" "}
        Did you know that a cow on a modern dairy farm will spend nearly all of
        her short life pregnant, so that milk production and profits can be
        maximized? The male calves, who are inconvenient by-products of that
        industry, are taken from their mothers within hours of birth, often to
        be chained at the neck in one spot for their entire, brief lives.
      </p>
      <br />
      <b>Egg Industry: </b>{" "}
      <p>
        You might not know that the egg industry has no use for newborn male
        chicks, so they are routinely tossed into plastic bags with hundreds of
        others and left to smother. Free range egg production is typically no
        different. Farmed Animals have individual personalities and love their
        lives just as we do. Our taste for meat supports an industry that
        confines and houses them in deplorable conditions; that deprives them of
        fresh air, sunlight, and freedom of movement; that frustrates nearly
        every need and natural instinct. How do we feel about this…
      </p>
      <br />
      <h4> EARTH FRIENDLY FOOD CHOICES: Did you know…</h4>
      <br />
      <b>Climate Change:</b>{" "}
      <p>
        A recent UN report says that livestock produce more climate-changing
        greenhouse gases than do all forms of transportation combined. The human
        appetite for animal flesh is also a driving force behind air and water
        pollution, soil erosion, deforestation, and fresh water scarcity. Our
        meat eating habit poses a serious threat to our future. Modern meat
        production uses massive amounts of water, grains, fossil fuels and other
        resources to convert plant foods, which are naturally low in fat, high
        in fiber, and contain no cholesterol at all, into a food that is high in
        fat, high in cholesterol, and contains no fiber at all.
      </p>
      <br />
      <b>Shrimp & Fish:</b>{" "}
      <p>
        {" "}
        Did you know that for every pound of shrimp that we take from the ocean
        for food, we throw back another 20 pounds of mostly dead and dying sea
        life? And fish are being harvested in much the same way, with
        devastating results for marine ecosystems.
      </p>
      <br />
      <b>Chicken Manure:</b>
      <p>
        Did you know that the poultry industry on the Delmarva peninsula
        produces 1 million tons of chicken manure every year? It's a primary
        source of dangerous bacteria and nutrients that steal oxygen from our
        waterways. And it’s the main reason why so little progress has been made
        on restoring the Chesapeake Bay.
      </p>
      <br />
      <b>Fishing Industry:</b>{" "}
      <p>
        {" "}
        Did you know that virtually every species of seafood is either already
        severely overfished or being harvested at maximum sustainable levels?
        There's simply no way to balance recommendations to eat more fish with
        the state of the world's oceans, & certainly not with a world population
        about to hit 7 billion!
      </p>
      <br />
      <b>Hunger:</b>{" "}
      <p>
        {" "}
        Industrialized meat production is very inefficient, and squanders
        precious resources that could be used alleviate hunger. 80% of American
        farmland is used to grow grains, beans, and grasses to feed livestock.
        Our farms could provide for about 7 times as many people who adhere to a
        purely plant-based diet.
      </p>
      <br />
      <h4>Personal Meaning, Spirituality, Peace</h4>
      <br />
      <b>Early Native Americans</b>
      <p>
        {" "}
        hunted animals out of necessity and revered them as their brothers and
        sisters who, as they believed, were offering their bodies willingly so
        that others may live. Indians referred to the white man's livestock as
        "slave animals". Which of us, who has seen the way animals are treated
        in today's mass production of meat, dairy, and eggs, could imagine that
        any living being would go willingly into that process? And where is our
        reverence when we are killing purely for our own comforts… Where is the
        reverence when our food choices are damaging our own health and the
        health of the earth…
      </p>
      <br />
      <b>Will Tuttle, PhD,</b>
      <p>
        {" "}
        author of "The World Peace Diet", sees animal agriculture - which
        requires a desensitization to violence - as a root cause of oppression,
        exploitation and spiritual disconnectedness. Such a reduction of
        essential feelings, awareness, and intelligence serves to perpetuate
        violence & war.
      </p>
      <br />
      <b>Adopting a plant based diet</b>
      <p>
        {" "}
        is one of the most loving things we can do. It’s a way of loving
        ourselves enough to really care about our health and our time left on
        earth; a way of loving and respecting animals enough to allow them their
        own place in nature, aside from what they can do for us; and a way of
        loving our planet enough to allow its beauty and resources, and its
        magical healing properties to be here for generations yet to come.
      </p>
      <br />
      <b>We’ve been blessed</b>
      <p>
        {" "}
        with bodies that don't require us to take the lives and the freedom of
        those with whom we share the planet. As we begin to eat and live more
        simply and sustainably, we bring our lives into greater alignment with
        our true peaceful nature. We grow in wisdom and share the joy of living
        with an ever broadening circle of friends.
      </p>
      <br />
      <h4> ~QUOTES of Note~ HEALTHIER FOOD CHOICES</h4>
      <br />
      <p>
        <b>"Your choice of diet</b> can influence your long term health
        prospects more than any other action you might take."{" "}
      </p>
      <p>
        Former U.S. Surgeon General <b> ~C. Everett Koop~ </b>
      </p>
      <br />
      <p>
        <b>"The vast majority</b> ,perhaps 80%-90%, of all cancers,
        cardiovascular and other forms of degenerative illness can be prevented,
        at least to a very old age, simply by adopting a plant-based diet. ...No
        chemical carcinogen is nearly so important in causing human cancer as
        animal protein."
      </p>
      <p>
        <b> ~T. Colin Campbell, PhD~</b> Director of the China Study, the most
        comprehensive large study ever undertaken of the relationship between
        diet and disease.
      </p>
      <br />
      <p>
        {" "}
        <b>"There is virtually</b> no evidence that drinking two or three
        glasses of milk a day reduces the chances of breaking a bone."
      </p>
      <p>
        {" "}
        <b> ~Walter C. Willet, MD~</b> Chairman of the Department of Nutrition,
        Harvard School of Public Health
      </p>
      <br />
      <p>
        {" "}
        <b>There’s no reason</b> to drink cow’s milk at any time in your life.
        It was designed for calves, it was not designed for humans, and we
        should all stop drinking it today."
      </p>
      <p>
        {" "}
        <b> ~Dr. Frank Oski,~</b> former director of pediatrics, Johns Hopkins
        University~
      </p>
      <br />
      <p>
        <b>"Another good reason</b> to get your nutrition from plant sources is
        that animals tend to concentrate pesticides and other chemicals in their
        meat and milk... Plant foods have much less contamination..."
      </p>
      <p>
        <b> ~Benjamin Spock, MD~ </b>Pediatrician and author of all time best
        selling books on health care for children
      </p>
      <br />
      <p>
        {" "}
        <b> "It is the position</b> of the American Dietetic Association that
        appropriately planned vegetarian diets, including total vegetarian or
        vegan diets, are healthful, nutritionally adequate, and may provide
        health benefits in the prevention and treatment of certain diseases.
        Well-planned vegetarian diets are appropriate for individuals during all
        stages of the life cycle, including pregnancy, lactation, infancy,
        childhood, and adolescence, and for athletes."
      </p>
      <b> ~American Dietetic Association~</b>
      <p>
        <b>"Whether industrialized societies… </b>can cure themselves of their
        meat addictions may ultimately be a greater factor in world health than
        all the doctors, health insurance policies, and drugs put together."
      </p>
      <p>
        <b>~T. Colin Campbell, PhD~</b> who was lead scientist in the huge
        China-Oxford-Cornell Project on Nutrition
      </p>
      <br />
      <h4>~QUOTES of Note~ COMPASSIONATE FOOD CHOICES</h4>
      <br />
      <p>
        <b>"There is no fundamental difference</b>between man and the higher
        animals in their mental faculties... The lower animals, like man,
        manifestly feel pleasure and pain, happiness and misery."
      </p>
      <p>
        <b>~Charles Darwin~</b> Naturalist, and author of Origin of the Species
      </p>
      <br />
      <p>
        <b>"The vast majority</b> of farm animals today are raised in conditions
        which would shock our consciences. Most people assume that there are
        laws which protect farm animals from egregious abuse. But what few laws
        exist are almost never enforced. Consequently, since profit is deemed
        more important than comfort for the animal, farm animals are routinely
        and patently abused and neglected."
      </p>
      <p>
        <b>~John Robbins~</b> Author of Diet for a New America, and Food
        Revolution
      </p>
      <br />
      <p>
        <b>"If slaughterhouses</b> had glass walls, everyone would be
        vegetarian."
      </p>
      <p>
        <b>~Paul McCartney~</b>
      </p>
      <br />
      <h4>
        <b>~QUOTES of Note~ EARTH-FRIENDLY FOOD CHOICES</b>
      </h4>
      <br />
      <p>
        <b>"More global warming greenhouse gases</b> are produced by livestock
        operations than by all forms of transportation combined."
      </p>
      <p>
        <b>~United Nations Report: Livestock's Long Shadow~</b> 11/9/06
      </p>
      <br />
      <p>
        <b>"We will find</b> that we can no longer subsidize or ignore the costs
        of mass-producing cattle, poultry, pigs, sheep, and fish to feed our
        growing population. These costs include hugely inefficient use of fresh
        water and land, heavy pollution from livestock feces, rising rates of
        heart disease and other degenerative illnesses, and spreading
        destruction of forests on which much of the planet’s life depends."{" "}
      </p>
      <p>
        <b>~Time Magazine~ </b>11/8/99
      </p>
      <br />
      <p>
        <b>"Nothing will benefit human health</b> and increase chances for
        survival of life on Earth as much as the evolution to a vegetarian
        diet."
      </p>
      <p>
        <b>~Albert Einstein~ </b> Physicist, Nobel Prize 1921
      </p>
    </Page>
  );
}
